import React, { useContext } from 'react';
import ImportIcone from '@mui/icons-material/UploadFile';
import RestructurationIcone from '@mui/icons-material/AccountTree';
import UtilisateursIcone from '@mui/icons-material/ManageAccounts';
import ClientIcone from '@mui/icons-material/ContactPage';
import AdminIcone from '@mui/icons-material/Groups';
import ServeurIcone from '@mui/icons-material/Dns';
import ReportIcone from '@mui/icons-material/Assignment';
import LogoutIcone from '@mui/icons-material/Logout';
import DeploymentIcone from '@mui/icons-material/SignalCellularAlt';
import FeaturesIcone from '@mui/icons-material/LockOpen';
import CopieIcone from '@mui/icons-material/ContentCopy';
import CreationIcone from '@mui/icons-material/AddCircle';
import BarChartIcone from '@mui/icons-material/BarChart';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcone from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Drawer from '@mui/material/Drawer';
import './drawer.css';
import { baseSelectionneeContext } from '../../../App';


const DrawerCmb = props => {
    const sharedStyle = (props.isDesktop) ? 'drawer-paper desktop' : 'drawer-paper';
    const pages = {
        HOME: 0,
        IMPORT: 1,
        DEPLOIEMENT: 2,
        FONCTIONNALITES: 3,
        DONNEES_CLIENT: 4,
        INFRASTRUCTURE: 5,
        UTILISATEURS: 6,
        RESTRUCTURATION: 7,
        CREATION_WEBAPP: 8,
        COPIE: 9,
        STATISTIQUES: 10,
        DONNEES_ADMIN: 11,
    }
    const valeurBase = localStorage.getItem('baseSelectionnee');
    const { baseSelectionnee, setBaseSelectionnee } = useContext(baseSelectionneeContext);
    window.baseSelectionnee = baseSelectionnee;
    const changerBase = event => {
        const valeurBase = event.target.value;
        setBaseSelectionnee(valeurBase);
        window.baseSelectionnee = valeurBase;
        localStorage.setItem('baseSelectionnee', valeurBase);
    };
    return (
        <Drawer variant="permanent"
            open={props.opened}
            className={`barre-gauche ${(props.opened) ? sharedStyle : sharedStyle + ' close'}`}
            classes={{
                paper: `${(props.opened) ? sharedStyle : sharedStyle + ' close'}`
            }}>
            <div className="toolbarIcone">
                <div className="choix-db">
                    <label htmlFor={"choix-db"}>
                        Base sélectionnée :
                    </label>
                    <select id={"choix-db"} value={baseSelectionnee} onChange={changerBase}>
                    {props.environnementsDisponibles && Object.entries(props.environnementsDisponibles).map(([env, details]) => (
                        <option key={env} value={env}>{details.nom}</option>
                    ))}
                    </select>
                </div>
            </div>
            <Divider />
            <List>
                <ListItemButton selected={props.selectedIndex === pages.HOME}
                    onClick={() => props.handleListItemClick( pages.HOME )}>
                    <ListItemIcone>
                        <ReportIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Accueil"} />
                </ListItemButton>
                {(localStorage.getItem('Droit_Donnees_Client') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.DONNEES_CLIENT}
                    onClick={() => props.handleListItemClick( pages.DONNEES_CLIENT )}>
                    <ListItemIcone>
                        <ClientIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Données client"} />
                </ListItemButton>
                )}
                {(localStorage.getItem('Droit_Donnees_Admin') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.DONNEES_ADMIN}
                    onClick={() => props.handleListItemClick( pages.DONNEES_ADMIN )}>
                    <ListItemIcone>
                        <AdminIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Données admin"} />
                </ListItemButton>
                )}
                {
                <ListItemButton selected={props.selectedIndex === pages.IMPORT}
                    onClick={() => props.handleListItemClick( pages.IMPORT )}>
                    <ListItemIcone>
                        <ImportIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Import"} />
                </ListItemButton>
                }
                {(localStorage.getItem('Droit_Infrastructure') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.INFRASTRUCTURE}
                    onClick={() => props.handleListItemClick( pages.INFRASTRUCTURE )}>
                    <ListItemIcone>
                        <ServeurIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Infrastructure"} />
                </ListItemButton>
                )}
                {(localStorage.getItem('Droit_Deploiement') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.DEPLOIEMENT}
                    onClick={() => props.handleListItemClick( pages.DEPLOIEMENT )}>
                    <ListItemIcone>
                        <DeploymentIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Déploiement"} />
                </ListItemButton>
                )}
                {(localStorage.getItem('Droit_Fonctionnalites') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.FONCTIONNALITES}
                    onClick={() => props.handleListItemClick( pages.FONCTIONNALITES )}>
                    <ListItemIcone>
                        <FeaturesIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Fonctionnalités"} />
                </ListItemButton>
                )}
                {(localStorage.getItem('Droit_Copie') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.COPIE}
                    onClick={() => props.handleListItemClick( pages.COPIE )}>
                    <ListItemIcone>
                        <CopieIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Copie données"} />
                </ListItemButton>
                )}
                {(localStorage.getItem('Droit_Creation') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.CREATION_WEBAPP}
                    onClick={() => props.handleListItemClick( pages.CREATION_WEBAPP )} id="bouton-creation-webapp">
                    <ListItemIcone>
                        <CreationIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Création Webapp"} />
                </ListItemButton>
                )}
                {(localStorage.getItem('Droit_Utilisateurs') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.UTILISATEURS}
                    onClick={() => props.handleListItemClick( pages.UTILISATEURS )}>
                    <ListItemIcone>
                        <UtilisateursIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Utilisateurs"} />
                </ListItemButton>
                )}
                {/*(localStorage.getItem('Droit_Restructuration') === '1' &&
                <ListItemButton selected={props.selectedIndex === pages.RESTRUCTURATION}
                    onClick={() => props.handleListItemClick( pages.RESTRUCTURATION )}>
                    <ListItemIcone>
                        <RestructurationIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Restructuration"} />
                </ListItemButton>
                )
                */}
                <ListItemButton selected={props.selectedIndex === pages.STATISTIQUES}
                    onClick={() => props.handleListItemClick( pages.STATISTIQUES )}>
                    <ListItemIcone>
                        <BarChartIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Statistiques"} />
                </ListItemButton>
                <ListItemButton onClick={() => props.surDeconnexion()}>
                    <ListItemIcone>
                        <LogoutIcone />
                    </ListItemIcone>
                    <ListItemText primary={"Déconnexion"} />
                </ListItemButton>
            </List>
        </Drawer>
    );
};

export default DrawerCmb;
